import { render, staticRenderFns } from "./AddPermission.vue?vue&type=template&id=0c93801b"
import script from "./AddPermission.vue?vue&type=script&lang=ts"
export * from "./AddPermission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports